// tslint:disable: no-inputs-metadata-property

import {
  CDK_ROW_TEMPLATE,
  CdkFooterRow,
  CdkFooterRowDef,
  CdkHeaderRow,
  CdkHeaderRowDef,
  CdkRow,
  CdkRowDef
} from '@angular/cdk/table';
import { ChangeDetectionStrategy, Component, Directive, ViewEncapsulation, HostBinding } from '@angular/core';

/**
 * Header row definition for the suka-table.
 * Captures the header row's template and other header properties such as the columns to display.
 */
@Directive({
  selector: '[sukaHeaderRowDef]',
  providers: [{ provide: CdkHeaderRowDef, useExisting: SukaHeaderRowDef }],
  inputs: ['columns: sukaHeaderRowDef', 'sticky: sukaHeaderRowDefSticky'],
})
export class SukaHeaderRowDef extends CdkHeaderRowDef {
}

/**
 * Footer row definition for the suka-table.
 * Captures the footer row's template and other footer properties such as the columns to display.
 */
@Directive({
  selector: '[sukaFooterRowDef]',
  providers: [{ provide: CdkFooterRowDef, useExisting: SukaFooterRowDef }],
  inputs: ['columns: sukaFooterRowDef', 'sticky: sukaFooterRowDefSticky'],
})
export class SukaFooterRowDef extends CdkFooterRowDef {
}

/**
 * Data row definition for the suka-table.
 * Captures the data row's template and other properties such as the columns to display and
 * a when predicate that describes when this row should be used.
 */
@Directive({
  selector: '[sukaRowDef]',
  providers: [{ provide: CdkRowDef, useExisting: SukaRowDef }],
  inputs: ['columns: sukaRowDefColumns', 'when: sukaRowDefWhen'],
})
export class SukaRowDef<T> extends CdkRowDef<T> {
}

/** Footer template container that contains the cell outlet. Adds the right class and role. */
@Component({
  selector: 'suka-header-row, tr[suka-header-row]',
  template: CDK_ROW_TEMPLATE,
  // See note on CdkTable for explanation on why this uses the default change detection strategy.
  // tslint:disable-next-line:validate-decorators
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'sukaHeaderRow',
  providers: [{ provide: CdkHeaderRow, useExisting: SukaHeaderRow }],
})
export class SukaHeaderRow extends CdkHeaderRow {
  @HostBinding('class.suka-header-row') baseClass = true;
  @HostBinding('attr.role') role = 'row';
}

/** Footer template container that contains the cell outlet. Adds the right class and role. */
@Component({
  selector: 'suka-footer-row, tr[suka-footer-row]',
  template: CDK_ROW_TEMPLATE,
  // See note on CdkTable for explanation on why this uses the default change detection strategy.
  // tslint:disable-next-line:validate-decorators
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'sukaFooterRow',
  providers: [{ provide: CdkFooterRow, useExisting: SukaFooterRow }],
})
export class SukaFooterRow extends CdkFooterRow {
  @HostBinding('class.suka-footer-row') baseClass = true;
  @HostBinding('attr.role') role = 'row';
}

/** Data row template container that contains the cell outlet. Adds the right class and role. */
@Component({
  selector: 'suka-row, tr[suka-row]',
  template: CDK_ROW_TEMPLATE,
  // See note on CdkTable for explanation on why this uses the default change detection strategy.
  // tslint:disable-next-line:validate-decorators
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'sukaRow',
  providers: [{ provide: CdkRow, useExisting: SukaRow }],
})
export class SukaRow extends CdkRow {
  @HostBinding('class.suka-row') baseClass = true;
  @HostBinding('attr.role') role = 'row';
}
